import Image from 'next/image';
import classes from './ImageList.module.scss';

const ImageList = ({ data }) => {
    return (
        <div className={classes.mImageList}>
            {data.map((item) => (
                <figure key={item.id} className={classes.mImage}>
                    <Image
                        src={item?.image?.data?.attributes?.url}
                        alt={item?.image?.data?.attributes?.title}
                        width={item?.image?.data?.attributes?.width}
                        height={item?.image?.data?.attributes?.height}
                        className={classes.aImage}
                        aria-hidden="true"
                        layout="responsive"
                    />
                </figure>
            ))}
        </div>
    );
};

export default ImageList;
